module.exports = __webpack_public_path__ + "img/button-bg.c153bbe.png";